import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import type OnboardingStore from "./OnboardingStore";
import { ALL_ONBOARDING } from "./OnboardingStore";

const storeOf = (rootStore: RootStore) =>
  (rootStore as unknown as { onboardingViewStore?: OnboardingStore }).onboardingViewStore;

/**
 * Clients → Onboarding: every client still onboarding — its stage, how far its
 * checklist has got, what is overdue and what is next, and who owns it
 * (Blake's onboarding tracker in HQ, #3075 / #2663). Read-only: a row opens the
 * client's Onboarding tab, where the checklist is kept.
 *
 * A literal path: registered BEFORE ClientDetail's `/clients/:id`.
 */
const onboardingRoute: RouteType[] = [
  {
    name: "ClientOnboarding",
    path: "/clients/onboarding",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Onboarding",
        enableRefreshButton: true,
        component: () => import("./Onboarding.Header"),
      },
      body: { component: () => import("./Onboarding.Body") },
    },
    group: "Clients",
    searchAliases: ["onboarding", "checklist", "go-live", "implementation", "stalled onboarding"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void storeOf(rootStore)?.initialize(ALL_ONBOARDING);
    },
    onExit: ({ rootStore }) => {
      storeOf(rootStore)?.reset();
    },
  },
];

export default onboardingRoute;
